import axios from "axios";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import CriticalDPModal from '../CriticalDPPopup/CriticalDPModal.vue';
import ThresholdInfoPopup from '../ThresholdInfoPopup/ThresholdInfoPopup.vue';

export default {
  name: "ThresholdPopup",
  components: {
    customModal, 
    CriticalDPModal,
    ThresholdInfoPopup
 },
  props: {
    studyId: {
      type: String,
      default:"",
    },
    riskId:{
        type: String,
        default: "",
    },
    version: {
        type: String,
        default: ""
    }

  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      idToken: store.getters.getIdToken,
      headerValues: {},
      criticalDataPoints:[],
      showCriricalPopUp: false,
      showThresholdInfo: false,
      thresholdDetails: {},
    };
  },
  async mounted() {
    console.log("CriticalDPModal component mounted");
    this.headerValues = {
        headers: {
            Authorization: "Bearer " + this.idToken,
            "Content-Type": "application/json",
        },
    };
    await this.getCriticaldataPoints();
  },
  methods: {
    async getCriticaldataPoints(){
        try{
            var res = await axios.get(`${this.baseurl}/forms/rbqm/getcriticaldatapoints?studyId=${this.studyId}&riskId=${this.riskId}&version=${this.version}&isActive=true`, this.headerValues);
            console.log("Critical Data Points:", res.data);
            this.criticalDataPoints = res.data.entities;
        }
        catch (error) {
            console.error("Error fetching critical data points:", error);
        }
    },
    closeModal() {
      this.$emit("closeThresholdModal");
    },
    async showCriticalDP(item){
        this.dpPayload = item;
        this.showCriricalPopUp = true; 
    },
    async closeCriticalDataPopup() {
        this.showCriricalPopUp = false;
    },
    async showThresholdInfo(item){
      this.showThreshold = true;
      this.thresholdDetails = item.thresholds;
    },
    async closeThresholdInfo() {
        this.showThreshold = false;
        this.thresholdDetails = {};
    },
  },
};